import BreadcrumbsMixin from '../../Mixins/BreadcrumbsMixin';
import UserComponentMixin from '../../Mixins/UserComponentMixin';

export default {
  mixins: [BreadcrumbsMixin, UserComponentMixin]
};
